<div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="column">
      <h2 class="row">{{ "system-params.title" | translate }}</h2>
      <mat-paginator
      [length]="totalElements"
      [pageSizeOptions]="[5, 10, 25, 400]"
      [pageSize]="this.defaultPageSize"
      #paginator
      showFirstLastButtons
      (page)="this.handlePageEvent($event)"
    ></mat-paginator>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="end center"
      class="searchbox"
    >
      <mat-form-field style="margin-right: 15px">
        <input
          matInput
          [placeholder]="placeholderSearch"
          #filter
        />
      </mat-form-field>
      <div *ngIf="topMenuIcons.length > 0">
        <button
          mat-raised-button
          *ngFor="let action of topMenuIcons"
          [routerLink]="action.routerLink"
          (click)="this[action.clickMethod]()"
        >
          <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
        </button>
      </div>
      <button
        mat-raised-button
        (click)="exporter.exportTable('xlsx', {fileName:exportPrefix+formatted})">
        <mat-icon
          [title]="titleExcel">download
        </mat-icon>
      </button>
    </div>
  </div>

  <div class="top-table-sticky-header">
  <mat-table
    [dataSource]="dataSource"
    [paginator]="paginator"
    [filter]="filter"
    class="mat-elevation-z8"
    matSort
    [matSortActive]="this.defaultSort.active"
    [matSortDirection]="this.defaultSort.direction"
    matSortDisableClear
    appNgMatTableQueryReflector
    matTableExporter
    #exporter="matTableExporter"
    [hiddenColumns]="[0]"
  >
    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle">
        id
      </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.id }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="key">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "system-param.key" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("system-param.key" | translate) + ":"'>
        {{ element.key }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="value">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "system-param.value" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("system-param.value" | translate) + ":"'>
        {{ element.value }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" class="one_actions"> </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title one_actions">
        <div *ngIf="actions.length > 0">
          <button
            class="icon-button"
            *ngFor="let action of actions"
            [routerLink]="action.routerLink + element.id"
            (click)="this[action.clickMethod](element.id)"
            [state]="{ listdata: listIds }"
          >
            <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
  </div>




